import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLinkIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { business } from '../data/business';
import { copy } from '../data/copy';
import { services } from '../data/services';
import { useLanguage } from '../contexts/LanguageContext';
import { Stars } from './Stars';
const quickLinks = [{
  to: '/',
  label: copy.nav.home
}, {
  to: '/about',
  label: copy.nav.about
}, {
  to: '/services',
  label: copy.nav.services
}, {
  to: '/gallery',
  label: copy.nav.gallery
}, {
  to: '/reviews',
  label: copy.nav.reviews
}, {
  to: '/faq',
  label: copy.nav.faq
}, {
  to: '/contact',
  label: copy.nav.contact
}];
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-navy-950 text-navy-300" data-id="element-142" data-mp="3qc445h4tcaoa">
      <div className="mx-auto max-w-7xl px-6 py-14" data-id="element-143" data-mp="29zgkq0kfasm4">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4" data-id="element-144" data-mp="29xm0ypkw16jm">
          <div data-id="element-145" data-mp="2eyjpdjwhqwtk">
            <div className="flex items-center gap-3" data-id="element-146" data-mp="2ez1iw8rrqwxs">
              <img src={business.logoUrl} alt={`${business.name} logo`} className="h-14 w-14 rounded-full object-cover" data-id="element-147" data-mp="3l9adtjp9964y" />
              <span className="font-display text-lg font-bold text-white" data-id="element-148" data-mp="3gctrmv1m91ui">
                A&amp;J Auto Repair LLC
              </span>
            </div>
            <address className="mt-5 space-y-1 not-italic text-sm leading-relaxed" data-id="element-149" data-mp="3q7lr64erdyrx">
              <p data-id="element-150" data-mp="828ly3a19z83">{business.address}</p>
              <p data-id="element-151" data-mp="817d85ghpotj">{business.cityState}</p>
              <p className="pt-2" data-id="element-152" data-mp="34723g4s9vvk">
                <a href={business.phoneHref} className="font-bold text-white hover:text-gold-300" data-id="element-153" data-mp="335ujlmz7ril">
                  {business.phoneDisplay}
                </a>
              </p>
              <p data-id="element-154" data-mp="cvtma1z3n5ag">
                <a href={`mailto:${business.email}`} className="hover:text-gold-300" data-id="element-155" data-mp="qthzqoqu7a5h">
                  {business.email}
                </a>
              </p>
            </address>
            <p className="mt-4 text-sm" data-id="element-156" data-mp="tvw8wk94jlhk">{t(business.hoursSummary)}</p>
            <p className="mt-2 text-sm text-navy-400" data-id="element-157" data-mp="yty0xuoj2v56">
              <span className="font-semibold text-navy-300" data-id="element-158" data-mp="yupii1laiscg">
                {t(copy.footer.serviceAreaLabel)}:
              </span>{' '}
              {t(business.serviceArea)}
            </p>
          </div>

          <div data-id="element-159" data-mp="18lbvrp5jb6rz">
            <h2 className="font-display text-sm font-bold uppercase tracking-wider text-white" data-id="element-160" data-mp="18lu1rdi00zd3">
              {t(copy.footer.quickLinks)}
            </h2>
            <ul className="mt-5 space-y-2.5 text-sm" data-id="element-161" data-mp="1hje30mfv2vnp">
              {quickLinks.map(link => <li key={link.to} data-id="element-162" data-mp="1ml3fm6iqfhdw">
                  <Link to={link.to} className="transition-colors duration-150 ease-smooth hover:text-gold-300" data-id="element-163" data-mp="1mhpfl4xjjk9m">
                    {t(link.label)}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div data-id="element-164" data-mp="3tc2wl1oskzh6">
            <h2 className="font-display text-sm font-bold uppercase tracking-wider text-white" data-id="element-165" data-mp="2af3upvql3dm9">
              {t(copy.footer.servicesHeading)}
            </h2>
            <ul className="mt-5 space-y-2.5 text-sm" data-id="element-166" data-mp="25mu38b9tm5hv">
              {services.slice(0, 7).map(service => <li key={service.slug} data-id="element-167" data-mp="21kpfft620335">
                  <Link to={`/services#${service.slug}`} className="transition-colors duration-150 ease-smooth hover:text-gold-300" data-id="element-168" data-mp="1wo8pquj7hgny">
                    {t(service.name)}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div data-id="element-169" data-mp="2kc8ddll80qyb">
            <h2 className="font-display text-sm font-bold uppercase tracking-wider text-white" data-id="element-170" data-mp="2kbqc2ajpbmjj">
              {t(copy.footer.reviewsHeading)}
            </h2>
            <div className="mt-5 rounded-lg border border-navy-800 bg-navy-900 p-4" data-id="element-171" data-mp="18ynx1jx9351h">
              <div className="flex items-center gap-2" data-id="element-172" data-mp="13zb9ewyk1txu">
                <span className="font-display text-2xl font-bold text-white" data-id="element-173" data-mp="13xqdp40i84ye">
                  {business.rating}
                </span>
                <Stars rating={business.rating} data-id="element-174" data-mp="2wmg1l22crzi6" />
              </div>
              <p className="mt-1 text-sm" data-id="element-175" data-mp="2wnr5r2zpn99t">
                {business.reviewCount} {t(copy.footer.googleReviews)}
              </p>
              <a href={business.reviewsUrl} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-gold-300 hover:text-gold-200" data-id="element-176" data-mp="2ntw8si8qsp59">
                {t(copy.cta.readGoogle)}
                <ExternalLinkIcon width={14} height={14} aria-hidden="true" data-id="element-177" data-mp="31lsua3fwo0so" />
              </a>
            </div>
            <div className="mt-4 grid gap-2" data-id="element-178" data-mp="36jufatww6a6s">
              <a href={business.phoneHref} className="flex min-h-[44px] items-center justify-center gap-2 rounded-md bg-gold-500 px-4 text-sm font-bold text-navy-950 transition-colors duration-150 ease-smooth hover:bg-gold-400" data-id="element-179" data-mp="36isu3wm5w7bc">
                <PhoneIcon width={16} height={16} aria-hidden="true" data-id="element-180" data-mp="1nkmoa8f56h4w" />
                {t(copy.cta.callNow)}
              </a>
              <a href={business.directionsUrl} target="_blank" rel="noreferrer" className="flex min-h-[44px] items-center justify-center gap-2 rounded-md border border-navy-700 px-4 text-sm font-bold text-white transition-colors duration-150 ease-smooth hover:bg-navy-900" data-id="element-181" data-mp="1ioz2m2zvc645">
                <MapPinIcon width={16} height={16} aria-hidden="true" data-id="element-182" data-mp="zx6b6d0g6syj" />
                {t(copy.cta.directions)}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-navy-800 pt-6 text-sm sm:flex-row sm:items-center sm:justify-between" data-id="element-183" data-mp="18xbeaaylz56w">
          <p data-id="element-184" data-mp="l65zlz4emiy6">
            © {new Date().getFullYear()} A&amp;J Auto Repair LLC.{' '}
            {t(copy.footer.rights)}
          </p>
          <p className="flex gap-5" data-id="element-185" data-mp="g6jnxu485arh">
            <Link to="/privacy" className="hover:text-gold-300" data-id="element-186" data-mp="2gb5b7hlz2zh5">
              {t(copy.footer.privacy)}
            </Link>
            <Link to="/terms" className="hover:text-gold-300" data-id="element-187" data-mp="2l8fbjsawgvjr">
              {t(copy.footer.terms)}
            </Link>
          </p>
        </div>
      </div>
    </footer>;
}